module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.95b69736.woff2";